export default {
    namespaced: true,
    state: {
        user_activities: [],
        details: {}
    },
    mutations: {
        SET_USER_ACTIVITIES(state, p){
            state.user_activities = [...p]
        },
        SET_OLDER_USER_ACTIVITIES(state, p){
            p.map(q => {
                state.user_activities.push(q)
            })
        },
        set_details(state, payload){
            state.details = payload
        }
    },
    getters: {
        getUserAcitivies: state => state.user_activities,
        get_details: state => state.details
    },
    actions: {
        setUserAcitivities({commit}, payload){
            commit('SET_USER_ACTIVITIES', payload)
        },
        setOlderUserActivities({commit}, payload){
            commit("SET_OLDER_USER_ACTIVITIES", payload)
        },
        set_details({commit}, payload){
            commit('set_details', payload)
        }
    }
}